import { URI } from '@/config/config'

export default async ({ rootState }, payload) => {
  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken
    },
    body: JSON.stringify(payload)
  }

  const requestList = await fetch(`${URI}control-panel/roles`, opts)
  const jsonResult = await requestList.json()

  if (jsonResult.errors) {
    return Promise.reject(jsonResult.errors)
  }

  return jsonResult.list
}